module.exports = __webpack_public_path__ + "static/media/instructions.f4f84d59.svg";